import React from "react";

function UnauthorizedMessage() {
  return (
    <div className="page-error" data-testid="page-error">
      <p>You are not authorized to view this screen!</p>
      <p>Select a valid choice from the screen menu.</p>
    </div>
  );
}

export default UnauthorizedMessage;
